<div class="bar-chart-container ion-text-center">
  <canvas baseChart #baseChart [datasets]="chartData" [labels]="chartLabel" [options]="chartOptions" [legend]="isShowLegend" [chartType]="chartType"></canvas>
</div>
